module.exports = __webpack_public_path__ + "img/dx1.17a633cd.png";